import { FC, Fragment } from 'react';
import { PerformDateFilterSelector } from '../perform-indicator/perform-indicator';
import { CustomerFilterDto } from '@servicetitan/application-data/marketing';
import * as Styles from './segment-parts.module.less';

interface CallProps {
    call: Partial<CustomerFilterDto>;
}

export const Call: FC<CallProps> = ({ call }) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Call</div>
        <div>
            <PerformDateFilterSelector
                name="Last Inbound Call Date"
                valueStatic={call.noInboundCallsSince}
                valueDynamic={call.noInboundCallsSinceRelative}
            />
            <PerformDateFilterSelector
                name="Last Outbound Call Date"
                valueStatic={call.noOutboundCallsSince}
                valueDynamic={call.noOutboundCallsSinceRelative}
            />
        </div>
    </Fragment>
);
